export class CommonEnums {
  static roles = {
    agent: "agent",
    agency: "agency",
    agency_owner: "agency_owner",
  };

  static taskStatus = {
    queued: "queued",
    completed: "completed",
    errored: "errored",
    processing: "processing",
  };

  static socialUploadStatus = {
    not_started:  "not_started",
    pending_for_social_media_upload: "pending_for_social_media_upload"
  }

  static designStatuses = {
    // Record status is in draft
    draft: "draft",

    // Design generation is pending
    pending: "pending",

    // Processing the design request
    processing: "processing",

    // Failed to start process of design generation
    failedToProcess: "failed_to_process",

    // Failed to generate design for social media post
    failedToGenerateDesigns: "failed_to_generate_designs",

    pendingForUpload: "pending_for_upload",

    // Design is generated and uploaded to social media successfully
    completed: "completed",

    // Design is generated and uploaded to social media successfully
    cancelled: "cancelled",

    trash: "trash",

    // Design is generated and upload is pending on social media
    pendingForSocialMediaUpload: "pending_for_social_media_upload",
    scheduledForUpload: "schedule_for_upload",
  };

  static agencyProfileViewSteps = {
    info: "info",
    brand_info: "brand_info",
    legal_and_tax_information: "legal_and_tax_information",
  };

  /**
   * Design activity statuses
   */
  static designActivityStatuses = {
    /**
     * Design generation is pending
     */
    pending: "pending",
    failedToProcess: "failed_to_process",
    failedToGenerateDesigns: "failed_to_generate_designs",
    pendingForUpload: "pending_for_upload",
    completed: "completed",
    pendingToUploadOnSocialMedia: "pending_to_upload_on_social_media",
  };

  static reviewPostTabs = {
    review_type: { key: "review_type", value: "Review Type" },
    post_type: { key: "post_type", value: "Post Type" },
    create_review: { key: "create_review", value: "Create Review" },
    configure_post: { key: "configure_post", value: "Configure Post" },
  };

  static announcementPostTabs = {
    announcement_type: { key: "announcement_type", value: "Announcement Type" },
    post_type: { key: "post_type", value: "Post Type" },
    select_template: { key: "select_template", value: "Select Template" },
    create_post: { key: "create_post", value: "Create Post" },
    configure_post: { key: "configure_post", value: "Configure Post" },
  };

  static festivalPostTabs = {
    festival_type: { key: "festival_type", value: "Festival Type" },
    post_type: { key: "post_type", value: "Post Type" },
    select_template: { key: "select_template", value: "Select Template" },
    create_post: { key: "create_post", value: "Create Post" },
    configure_post: { key: "configure_post", value: "Configure Post" },
  };

  static onBoardingPostTabs = {
    post_type: { key: "post_type", value: "Post Type" },
    create_post: { key: "create_post", value: "Create Post" },
    configure_post: { key: "configure_post", value: "Configure Post" },
  };

  static propertyPost = {
    select_property: { key: "select_property", value: "Select Property" },
    post_type: { key: "post_type", value: "Post Type" },
    property_stage: { key: "property_stage", value: "Property Stage" },
    setup_post: { key: "setup_post", value: "Setup Post" },
    property_info: { key: "property_info", value: "Property Info" },
    post_configuration: {
      key: "post_configuration",
      value: "Post Configuration",
    },
  };

  static propertyPostJourney = {
    select_property: { key: "select_property", value: "Select Property" },
    post_type: { key: "post_type", value: "Post Type" },
    property_stage: { key: "property_stage", value: "Property Stage" },
    setup_post: { key: "setup_post", value: "Setup Post" },
    property_info: { key: "property_info", value: "Property Info" },
    post_system: {
      key: "post_system",
      value: "Post System",
    },
  };

  static openHomeInfo = {
    open_home_info: { key: "open_home_info", value: "Info" },
    post_type: { key: "post_type", value: "Post Type" },
    configure_post: { key: "configure_post", value: "Post configuration" },
  };

  static scheduleAuction = {
    create_auction: { key: "create_auction", value: "Create Auction" },
    info: { key: "info", value: "Info" },
    post_type: { key: "post_type", value: "Post Type" },
    configure_post: { key: "configure_post", value: "Configure Post" },
    auction_info: { key: "auction_info", value: "Auction Info" },
    auction_settings: { key: "auction_settings", value: "Auction settings" },
    campaign_overview: { key: "campaign_overview", value: "Campaign overview" },
  };

  static agencyScheduleAuction = {
    create_auction: { key: "create_auction", value: "Create Auction" },
    info: { key: "info", value: "Auction Info" },
    post_type: { key: "post_type", value: "Post Type" },
    configure_post: { key: "configure_post", value: "Configure Post" },
  };

  static subscriptionType = {
    property_marketing: {
      key: "property_marketing",
      value: "Property Marketing",
    },
    agent_marketing: { key: "agent_marketing", value: "Agent Marketing" },
  };

  static selectorType = {
    subscription_type: "subscription_type",
    status: "status",
    subscription_plan: "subscription_plan",
    registration_status: "registration_status",
    post_type: "post_type",
    design_post_type: "design_post_type",
    listing_type: "listing_type",
    listing_type_all: "listing_type_all",
    user_role: "user_role",
    property_type: "property_type",
    brand_country: "brand_country",
  };

  static agencyEmployeeStatus = {
    active: {
      key: "active",
      value: "active",
    },
    deactivated: {
      key: "deactivated",
      value: "Deactivated",
    },
    archived: {
      key: "archived",
      value: "Archived",
    },
  };

  static DesignSetupTypes = {
    property_marketing_for_sale: "property_marketing_for_sale ",
    property_marketing_for_rent: "property_marketing_for_rent",
    agent_marketing_for_sale: "agent_marketing_for_sale",
    agent_marketing_for_rent: "agent_marketing_for_rent",
  };

  static listingType = {
    for_rent: {
      key: "rent",
      value: "For Rent",
    },

    for_sale: {
      key: "sale",
      value: "For Sale",
    },
  };

  static priceType = {
    per_property: { key: "per_property", value: "Per Property" },
    per_month: { key: "per_month", value: "Per Month" },
  };

  static availability_type = {
    available_now: "available_now",
    available_from: "available_from",
  };

  static pageType = {
    User: "User",
    Subscription: "Subscription",
    design_templates: "Design Templates",
    templates_type: "Templates Type",
    agencies: "Agencies",
    agents: "Agents",
  };

  static postTypes = {
    image_post: "image_post",
    video_post: "video_post",
    story_post: "story_post",
    reel_post: "reel_post",
  };

  static listing_Type = {
    rent: "rent",
    sale: "sale",
  };

  static fontConfiguration = {
    brand_fonts: "brand_fonts",
    agency_fonts: "agency_fonts",
  };

  static queryParams = {
    invitation_code: "invitation_code",
    register_as: "register_as",
    login_as: "login_as",
    agent_email: "agent_email",
    user_email: "user_email",
    agent_id: "agent_id",
    invitee_email: "invitee_email",

    user_type: "user_type",
    invitation_status: "invitation_status",
    start_date: "start_date",
    end_date: "end_date",

    propertiesFilter: {
      agents: "agents",
      property_type: "property_type",
      property_id: "property_id",
      property_stage: "property_stage",
      listing_type: "listing_type",
    },

    activitiesFilter: {
      agent_id: "agent_id",
      property_id: "property_id",
      property_stage: "property_stage",
      listing_type: "listing_type",
      post_type: "post_type",
      user_type: "user_type",
      review_type: "review_type",
      announcement_type: "announcement_type",
      festival_type: "festival_type",
      start_date: "start_date",
      end_date: "end_date",
      created_start_date: "created_start_date",
      created_end_date: "created_end_date",
      schedule_start_date: "schedule_start_date",
      schedule_end_date: "schedule_end_date",
      status: "status",
      review_post_title: "review_post_title",
      post_status: "post_status",
    },

    last_status: "last_status",
    action_type: "action_type",

    agentFilter: {
      agencies: "agencies",
      status: "status",
      registration_status: "registration_status",
      cities: "cities",
    },
    role: "role",

    subscription_type: "subscription_type",
    subscription_plan: "subscription_plan",
    template_type: "template_type",
    status: "status",

    agent_name: "agent_name",

    agency_id: "agency_id",
    agency_name: "agency_name",
    registration_status: "registration_status",
    selected_city_ids: "selected_city_ids",
    post_type: "post_type",
    stage_type: "stage_type",
    stage_type_name: "stage_type_name",
    listing_type: "listing_type",

    personalized_switch: "personalized_switch",

    brand_id: "brand_id",
    brand_name: "brand_name",

    inviter_role: "inviter_role",
    invitee_role: "invitee_role",
  };

  static announcement_post_types = {
    hiring: {
      label: "Hiring",
      slug: "hiring",
    },
    work_anniversary: {
      label: "Work Anniversary",
      slug: "work_anniversary",
    },
    birthday: {
      label: "Birthday",
      slug: "birthday",
    },
    events: {
      label: "Events",
      slug: "events",
    },
    transaction_success_showcase: {
      label: "Transaction Success Showcase",
      slug: "transaction_success_showcase",
    },
    office_holiday: {
      label: "Office Closure / Holiday",
      slug: "office_holiday",
    },
    awards: {
      label: "Awards / Recognition",
      slug: "awards",
    },
    promotions: {
      label: "Promotions / Role Changes",
      slug: "promotions",
    },
    office_relocation: {
      label: "Office Relocation / New Branch",
      slug: "office_relocation",
    },
  };

  static festival_post_types = {
    australia_day: {
      label: "Australia Day",
      slug: "australia_day",
    },
    valentines_day: {
      label: "Valentine’s Day",
      slug: "valentines_day",
    },
    easter: {
      label: "Easter",
      slug: "easter",
    },
    anzac_day: {
      label: "ANZAC Day",
      slug: "anzac_day",
    },
    mothers_day: {
      label: "Mother’s Day",
      slug: "mothers_day",
    },
    fathers_day: {
      label: "Father’s Day",
      slug: "fathers_day",
    },
    spring_season: {
      label: "Spring Season",
      slug: "spring_season",
    },
    christmas: {
      label: "Christmas",
      slug: "christmas",
    },
    new_year: {
      label: "New Year",
      slug: "new_year",
    },
    chinese_new_year: {
      label: "Chinese New Year",
      slug: "chinese_new_year",
    },
    eid_ramadan: {
      label: "Eid al-Fitr / Ramadan",
      slug: "eid_ramadan",
    },
    diwali: {
      label: "Diwali",
      slug: "diwali",
    },
    labour_day: {
      label: "Labour Day",
      slug: "labour_day",
    },
    halloween: {
      label: "Halloween",
      slug: "halloween",
    },
    melbourne_cup_day: {
      label: "Melbourne Cup Day",
      slug: "melbourne_cup_day",
    },
    eofy: {
      label: "EOFY (End of Financial Year)",
      slug: "eofy",
    },
    earth_day: {
      label: "Earth Day",
      slug: "earth_day",
    },
    international_womens_day: {
      label: "International Women’s Day",
      slug: "international_womens_day",
    },
    world_environment_day: {
      label: "World Environment Day",
      slug: "world_environment_day",
    },
    national_property_managers_day: {
      label: "National Property Managers Day",
      slug: "national_property_managers_day",
    },
    ru_ok_day: {
      label: "R U OK? Day",
      slug: "ru_ok_day",
    },
  };

  static pageTypes = {
    user: {
      key: "user",
      value: "User",
    },
    all_activities: {
      key: "all_activities",
      value: "All Activities",
    },
    subscriptions: {
      key: "subscriptions",
      value: "Subscriptions",
    },
    design_templates: {
      key: "design_templates",
      value: "Design Templates",
    },
    design_template_types: {
      key: "design_template_types",
      value: "Design Template Types",
    },

    agents: {
      key: "agents",
      value: "Agents",
    },

    agencies: {
      key: "agencies",
      value: "Agencies",
    },

    referral_programs: {
      key: "referral_programs",
      value: "Referral Programs",
    },

    referral_programs_agents: {
      key: "referral_programs_agents",
      value: "Referral Programs Agents",
    },

    referral_programs_agencies: {
      key: "referral_programs_agencies",
      value: "Referral Programs Agencies",
    },

    royalty_rograms: {
      key: "royalty_rograms",
      value: "Royalty Programs",
    },

    /// new
    properties: {
      key: "properties",
      value: "Properties",
    },
    manage_invites: {
      key: " manage_invites",
      value: " Manage Invites",
    },
    agency_employee: {
      key: " agency_employee",
      value: " Agency Employee",
    },
    agent_employee: {
      key: " agent_employee",
      value: " Agent Employee",
    },
    agency_agent_employee: {
      key: " agency_agent_employee",
      value: "Agency Agent Employee",
    },
  };

  static agentProfileSteps = {
    agentInfo: "agent_info",
    verifyPhone: "verify_phone",
    agencyInfo: "agency_info",
  };

  static agencyProfileSteps = {
    agentInfo: "agent_info",
    verifyPhone: "verify_phone",
    legalInfo: "legalInfo",
    agencyInfo: "agency_info",
    brandGrammer: "brand_grammar",
  };

  static agentRegistrationStatus = {
    pending: "pending",
    completed: "completed",
    draft: "draft",
    profile_completion_pending: "profile_completion_pending",
    pending_for_agency_registration: "pending_for_agency_registration",
    pending_for_agency_info: "pending_for_agency_info",
    pending_for_agent_info: "pending_for_agent_info",
    pending_for_legal_info: "pending_for_legal_info",
    pending_for_brand_grammar: "pending_for_brand_grammar",
    agency_registration_completed: "agency_registration_completed",
    completed_agent_info: "completed_agent_info",
    phone_verification_is_pending: "phone_verification_is_pending",
    verified_phone: "verified_phone",
    completing_agency_profile: "completing_agency_profile",
    email_verification_is_required: "email_verification_is_required",
    phone_verification_is_required: "phone_verification_is_required",
    waiting_for_registration_approval: "waiting_for_registration_approval",
  };

  // static inviteStatus = {
  //   pending_for_profile_completion: "pending_for_profile_completion",
  //   pending_for_subscription: "pending_for_subscription",
  //   pending_for_registration: "pending_for_registration",
  //   completed: "completed",
  // };

  static inviteStatus = {
    pending_for_profile_completion: {
      key: "profile_completion_pending",
      value: "Pending for Profile Creation",
    },

    pending_for_subscription: {
      key: "pending_for_subscription",
      value: "Pending As Paid Subscriber",
    },

    pending_for_registration: {
      key: "pending_for_registration",
      value: "Not Accepted",
    },

    completed: {
      key: "completed",
      value: "Completed & Both Rewarded",
    },
    completing_agency_profile: {
      key: "completing_agency_profile",
      value: "Waiting for completing agency profile",
    },

    waiting_for_registration_approval: {
      key: "waiting_for_registration_approval",
      value: "Waiting for registration approval",
    },
  };

  static approvalStatus = {
    pending: {
      key: "pending",
      value: "Pending",
    },

    rejected: {
      key: "rejected",
      value: "Rejected",
    },

    approved: {
      key: "approved",
      value: "Approved",
    },
  };

  static actionTypes = {
    resent_invitation: {
      key: "resent_invitation",
      value: "Invitation Resent",
    },

    sent_invitation_reminder: {
      key: "sent_invitation_reminder",
      value: "Invitation Reminder Sent",
    },

    invitation_sent: {
      key: "invitation_sent",
      value: "Invitation Sent",
    },
  };

  static invitationType = {
    invitation_by_email: "invitation_by_email",
    invitation_by_link: "invitation_by_link",
  };

  static userRole = {
    agent: "agent",
    agency: "agency",
  };

  static listingTypes = {
    residential: "residential",
    commercial: "commercial",
  };

  static propertyType = {
    sell: "sell",
    rent: "rent",
  };

  static priceTypes = {
    priceRange: "price-range",
    offerAboveXyzPrice: "offer-above-xyz-price",
    contentAgentForSell: "content-agent-for-sell",
    eoi: "eoi",
    priceGuideXyzPrice: "price-guide-xyz-price",
    pricePerWeek: "price-per-week",
    pricePerMonth: "price-per-month",
    contactAgent: "contact-agent",
  };

  static userStatus = {
    draft: "draft",
    trash: "trash",
    disabled: "disabled",
    disable: "disable",
    active: "active",
    deactivated: "deactivated",
    published: "published",
    unpublished: "unpublished",
  };

  static postType = {
    image_post: {
      key: "image_post",
      value: "Image Post",
    },
    image_story_post: {
      key: "image_story_post",
      value: "image_story_post Post",
    },
    video_post: { key: "video_post", value: "Video Post" },
    story_post: { key: "story_post", value: "Story Post" },
    reel_post: { key: "reel_post", value: "Reel Post" },
  };

  static status = {
    draft: "draft",
    trash: "trash",
    disabled: "disabled",
    disable: "disable",
    active: "active",
    deactivated: "deactivated",
    published: "published",
    pending_for_admin_approval: "pending_for_admin_approval",
    rejected_by_admin: "rejected_by_admin",
  };

  static agencyType = {
    independent: "independent",
    brand: "brand",
  };

  static approvStatus = {
    approved: "approved",
    rejected: "rejected",
  };

  static requestsStatus = {
    new: {
      key: "new",
      value: "New",
    },
    rejected: { key: "rejected", value: "Rejected" },
    approved: { key: "approved", value: "Approved" },
    all: { key: "all", value: "All" },
  };

  static agentsTabsType = {
    info: { key: "info", value: "Info" },
    permissions: { key: "permissions", value: "Permissions" },
    subscription: { key: "subscription", value: "Subscription" },
    payment_history: { key: "payment_history", value: "Payment history" },
    ledger: { key: "ledger", value: "Ledger" },
  };

  static accountSettingsTabs = {
    general: { key: "general", value: "Ganeral" },
    payment_methods: { key: "payment_methods", value: "Payment Methods" },
    social_accounts: {
      key: "social_accounts",
      value: "Social accounts",
    },
    configure_social_media_posting: {
      key: "configure_social_media_posting",
      value: "Configure Social Media Posting",
    },
    setup_property_stages: {
      key: "setup_property_stages",
      value: "Setup property stages",
    },
    post_settings: {
      key: "post_settings",
      value: "Post Settings",
    },
    open_home_posts: {
      key: "open_home_posts",
      value: "Open home posts",
    },
    auction_posts: {
      key: "auction_posts",
      value: "Auction posts",
    },
    recap_post_settings: {
      key: "recap_post_settings",
      value: "Recap Posts",
    },
    manage_subscriptions: {
      key: "manage_subscriptions",
      value: "Manage Subscriptions",
    },
    payment_history: {
      key: "payment_history",
      value: "Payment History",
    },
    other_post_settings: {
      key: "other_post_settings",
      value: "Others",
    },
    ledger: {
      key: "ledger",
      value: "Ledger",
    },
  };

  static activitiesTabs = {
    all_activities: { key: "all_activities", value: "All Activities" },
    invitations: { key: "invitations", value: "Invitations" },
    scheduled: { key: "scheduled", value: "Scheduled" },
    completed: { key: "completed", value: "Completed" },
    all: { key: "all", value: "All" },
    agencies: { key: "agencies", value: "Agencies" },
  };

  static designTypes = {
    open_home_for_sell: "open_home_for_sell",
    open_home_for_rent: "open_home_for_rent",
    open_home_post: "open_home_post",
    auction: "auction_post",
    announcement_post: "announcement_post",
    festival_post: "festival_post",
    onboarding_post: "onboarding_post",
    property_post: "property_post",
    review_post: "review_post",
  };

  static propertyStageIds = {
    for_rent: "67d807038602348b68f4ce48",
    open_home_for_rent: "67d807038602348b68f4ce49",
    coming_soon_for_rent: "67d807038602348b68f4ce47",
    leased: "67d807038602348b68f4ce4a",
    for_auction: "685db15ef6fa69efb3d27fff",
    coming_soon_for_sale: "67d807038602348b68f4ce41",
    just_listed: "67d807038602348b68f4ce40",
    for_sale: "67d807038602348b68f4ce42",
    sold: "67d807038602348b68f4ce46",
    open_home_for_sale: "681b4f34eda725ae221b819b",
    under_offer: "681b4f34eda725ae221b819c",
  };

  static templateTypes = {
    /**
     * Property Marketing - Standard Plan - For Rent
     */

    coming_soon_for_rent_image_post: {
      slug: "coming_soon_for_rent_image_post",
      listing_type: "rent",
      label: "Coming Soon Listing Image Post",
      label_for_internal_use: "Coming Soon Listing Image Post - For Rent",
      post_type: "image_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.coming_soon_for_rent,
      agency_post: false,
      video_post: false,
      multiple_properties_post: false,
    },
    coming_soon_for_rent_story_post: {
      slug: "coming_soon_for_rent_story_post",
      listing_type: "rent",
      label: "Coming Soon Listing Story Post",
      label_for_internal_use: "Coming Soon Listing Story Post - For Rent",
      post_type: "story_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.coming_soon_for_rent,
      agency_post: false,
      video_post: false,
    },
    for_rent_listing_image_post: {
      slug: "for_rent_listing_image_post",
      listing_type: "rent",
      label: "For Rent Listing Image Post",
      label_for_internal_use: "For Rent Listing Image Post", // Added
      post_type: "image_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.for_rent,
      agency_post: true,
      video_post: false,
      multiple_properties_post: false,
    },
    for_rent_listing_story_post: {
      slug: "for_rent_listing_story_post",
      listing_type: "rent",
      label: "For Rent Listing Story Post",
      label_for_internal_use: "For Rent Listing Story Post", // Added
      post_type: "story_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.for_rent,
      agency_post: false,
      video_post: false,
    },
    open_home_for_rent_listing_image_post: {
      slug: "open_home_for_rent_listing_image_post",
      listing_type: "rent",
      label: "Open Home Image Post",
      label_for_internal_use: "Open Home Image Post - For Rent",
      post_type: "image_post",
      design_type: this.designTypes.open_home_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.open_home_for_rent,
      agency_post: true,
      video_post: false,
      multiple_properties_post: true,
    },
    open_home_for_rent_listing_story_post: {
      slug: "open_home_for_rent_listing_story_post",
      listing_type: "rent",
      label: "Open Home Story Post",
      label_for_internal_use: "Open Home Story Post - For Rent",
      post_type: "story_post",
      design_type: this.designTypes.open_home_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.open_home_for_rent,
      agency_post: true,
      video_post: false,
      multiple_properties_post: true,
    },

    /**
     * Property Marketing - Standard Plan - For Sale
     */
    coming_soon_for_sale_image_post: {
      slug: "coming_soon_for_sale_image_post",
      listing_type: "sale",
      label: "Coming Soon Listing Image Post",
      label_for_internal_use: "Coming Soon Listing Image Post - For Sale",
      post_type: "image_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.coming_soon_for_sale,
      agency_post: false,
      video_post: false,
    },
    coming_soon_for_sale_story_post: {
      slug: "coming_soon_for_sale_story_post",
      listing_type: "sale",
      label: "Coming Soon Listing Story Post",
      label_for_internal_use: "Coming Soon Listing Story Post - For Sale",
      post_type: "story_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.coming_soon_for_sale,
      agency_post: false,
      video_post: false,
    },

    for_sale_listing_image_post: {
      slug: "for_sale_listing_image_post",
      listing_type: "sale",
      label: "For Sale Listing Image Post",
      label_for_internal_use: "For Sale Listing Image Post", // Added
      post_type: "image_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.for_sale,
      agency_post: false,
      video_post: false,
    },
    for_sale_listing_story_post: {
      slug: "for_sale_listing_story_post",
      listing_type: "sale",
      label: "For Sale Listing Story Post",
      label_for_internal_use: "For Sale Listing Story Post", // Added
      post_type: "story_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.for_sale,
      agency_post: false,
      video_post: false,
    },

    auction_for_sale_image_post: {
      slug: "auction_for_sale_image_post",
      listing_type: "sale",
      label: "Auction Image Post",
      label_for_internal_use: "Auction Image Post", // Added
      post_type: "image_post",
      design_type: this.designTypes.auction,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.for_auction,
      agency_post: false,
      video_post: false,
    },
    auction_for_sale_story_post: {
      slug: "auction_for_sale_story_post",
      listing_type: "sale",
      label: "Auction Story Post",
      label_for_internal_use: "Auction Story Post", // Added
      post_type: "story_post",
      design_type: this.designTypes.auction,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.for_auction,
      agency_post: false,
      video_post: false,
    },

    open_home_for_sale_image_post: {
      slug: "open_home_for_sale_image_post",
      listing_type: "sale",
      label: "Open Home Image Post",
      label_for_internal_use: "Open Home Image Post - For Sale",
      post_type: "image_post",
      design_type: this.designTypes.open_home_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.open_home_for_sale,
      agency_post: true,
      video_post: false,
      multiple_properties_post: true,
    },
    open_home_for_sale_story_post: {
      slug: "open_home_for_sale_story_post",
      listing_type: "sale",
      label: "Open Home Story Post",
      label_for_internal_use: "Open Home Story Post - For Sale",
      post_type: "story_post",
      design_type: this.designTypes.open_home_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.open_home_for_sale,
      agency_post: true,
      video_post: false,
      multiple_properties_post: true,
    },

    under_offer_for_sale_image_post: {
      slug: "under_offer_for_sale_image_post",
      listing_type: "sale",
      label: "Under Offer/Contract Image Post",
      label_for_internal_use: "Under Offer/Contract Image Post", // Added
      post_type: "image_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.under_offer,
      agency_post: false,
      video_post: false,
    },
    under_offer_for_sale_story_post: {
      slug: "under_offer_for_sale_story_post",
      listing_type: "sale",
      label: "Under Offer/Contract Story Post",
      label_for_internal_use: "Under Offer/Contract Story Post", // Added
      post_type: "story_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.under_offer,
      agency_post: false,
      video_post: false,
    },

    /**
     * Property Marketing - Growth Plan - For Rent
     */
    coming_soon_for_rent_video_post: {
      slug: "coming_soon_for_rent_video_post",
      listing_type: "rent",
      label: "Coming Soon Video Post",
      label_for_internal_use: "Coming Soon Video Post - For Rent",
      post_type: "video_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.coming_soon_for_rent,
      agency_post: false,
      video_post: false,
    },
    for_rent_listing_video_post: {
      slug: "for_rent_listing_video_post",
      listing_type: "rent",
      label: "For Rent Listing Video Post",
      label_for_internal_use: "For Rent Listing Video Post", // Added
      post_type: "video_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.for_rent,
      agency_post: false,
      video_post: false,
    },
    open_home_for_rent_video_post: {
      slug: "open_home_for_rent_video_post",
      listing_type: "rent",
      label: "Open Home Listing Video Post",
      label_for_internal_use: "Open Home Listing Video Post - For Rent",
      post_type: "video_post",
      design_type: this.designTypes.open_home_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.open_home_for_rent,
      agency_post: true,
      video_post: false,
      multiple_properties_post: true,
    },

    /**
     * Property Marketing - Growth Plan - For Sale
     */
    coming_soon_for_sale_video_post: {
      slug: "coming_soon_for_sale_video_post",
      listing_type: "sale",
      label: "Coming Soon Listing Video Post",
      label_for_internal_use: "Coming Soon Listing Video Post - For Sale",
      post_type: "video_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.coming_soon_for_sale,
      agency_post: false,
      video_post: false,
    },
    for_sale_listing_video_post: {
      slug: "for_sale_listing_video_post",
      listing_type: "sale",
      label: "For Sale Listing Video Post",
      label_for_internal_use: "For Sale Listing Video Post", // Added
      post_type: "video_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.for_sale,
      agency_post: false,
      video_post: false,
    },
    auction_for_sale_video_post: {
      slug: "auction_for_sale_video_post",
      listing_type: "sale",
      label: "Auction Listing Video Post",
      label_for_internal_use: "Auction Listing Video Post", // Added
      post_type: "video_post",
      design_type: this.designTypes.auction,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.for_auction,
      agency_post: false,
      video_post: false,
    },
    open_home_for_sale_video_post: {
      slug: "open_home_for_sale_video_post",
      listing_type: "sale",
      label: "Open Home Listing Video Post",
      label_for_internal_use: "Open Home Listing Video Post - For Sale",
      post_type: "video_post",
      design_type: this.designTypes.open_home_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.open_home_for_sale,
      agency_post: true,
      video_post: false,
      multiple_properties_post: true,
    },
    under_offer_for_sale_video_post: {
      slug: "under_offer_for_sale_video_post",
      listing_type: "sale",
      label: "Under Offer/Contract Listing Video Post",
      label_for_internal_use: "Under Offer/Contract Listing Video Post", // Added
      post_type: "video_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.under_offer,
      agency_post: false,
      video_post: false,
    },

    /**
     * Property Marketing - Success Plan - For Rent
     */

    coming_soon_for_rent_reel_post: {
      slug: "coming_soon_for_rent_reel_post",
      listing_type: "rent",
      label: "Coming Soon Reel Post",
      label_for_internal_use: "Coming Soon Reel Post - For Rent",
      post_type: "reel_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.coming_soon_for_rent,
      agency_post: false,
      video_post: false,
    },
    rent_listing_reel_post: {
      slug: "rent_listing_reel_post",
      listing_type: "rent",
      label: "For Rent Listing Reel Post",
      label_for_internal_use: "For Rent Listing Reel Post", // Added
      post_type: "reel_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.for_rent,
      agency_post: false,
      video_post: false,
    },
    open_home_for_rent_reel_post: {
      slug: "open_home_for_rent_reel_post",
      listing_type: "rent",
      label: "Open Home Listing Reel Post",
      label_for_internal_use: "Open Home Listing Reel Post - For Rent",
      post_type: "reel_post",
      design_type: this.designTypes.open_home_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.open_home_for_rent,
      agency_post: true,
      video_post: false,
      multiple_properties_post: true,
    },
    property_tour_shooted_video_for_rent_reel_post: {
      slug: "property_tour_shooted_video_for_rent_reel_post",
      listing_type: "rent",
      label: "Property Tour - Shooted Video Reel Post",
      label_for_internal_use:
        "Property Tour - Shooted Video Reel Post - For Rent",
      post_type: "reel_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      agency_post: false,
      video_post: false,
    },

    /**
     * Property Marketing - Success Plan - For Sale
     */
    coming_soon_for_sale_reel_post: {
      slug: "coming_soon_for_sale_reel_post",
      listing_type: "sale",
      label: "Coming Soon Reel Post",
      label_for_internal_use: "Coming Soon Reel Post - For Sale",
      post_type: "reel_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.coming_soon_for_sale,
      agency_post: false,
      video_post: false,
    },
    for_sale_listing_reel_post: {
      slug: "for_sale_listing_reel_post",
      listing_type: "sale",
      label: "For Sale Listing Reel Post",
      label_for_internal_use: "For Sale Listing Reel Post", // Added
      post_type: "reel_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.for_sale,
      agency_post: false,
      video_post: false,
    },
    auction_post_for_sale_reel_post: {
      slug: "auction_post_for_sale_reel_post",
      listing_type: "sale",
      label: "Auction Reel Post",
      label_for_internal_use: "Auction Reel Post", // Added
      post_type: "reel_post",
      design_type: this.designTypes.auction,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.for_auction,
      agency_post: false,
      video_post: false,
    },
    property_tour_shooted_video_for_sale_reel_post: {
      slug: "property_tour_shooted_video_for_sale_reel_post",
      listing_type: "sale",
      label: "Property Tour - Shooted Video Reel Post",
      label_for_internal_use:
        "Property Tour - Shooted Video Reel Post - For Sale",
      post_type: "reel_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      agency_post: false,
      video_post: false,
    },
    open_home_for_sale_reel_post: {
      slug: "open_home_for_sale_reel_post",
      listing_type: "sale",
      label: "Open Home For Sale Reel Post",
      label_for_internal_use: "Open Home For Sale Reel Post", // Added
      post_type: "reel_post",
      design_type: this.designTypes.open_home_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.open_home_for_sale,
      agency_post: true,
      video_post: false,
      multiple_properties_post: true,
    },
    under_offer_for_sale_reel_post: {
      slug: "under_offer_for_sale_reel_post",
      listing_type: "sale",
      label: "Under Offer/Contract Reel Post",
      label_for_internal_use: "Under Offer/Contract Reel Post", // Added
      post_type: "reel_post",
      design_type: this.designTypes.property_post,
      subscription_type: "property_marketing",
      stage_id: this.propertyStageIds.under_offer,
      agency_post: false,
      video_post: false,
    },

    /**
     * Agent Marketing - Standard Plan
     */
    sold_listing_image_post_agent_marketing: {
      slug: "sold_listing_image_post_agent_marketing",
      label: "SOLD Image Post",
      listing_type: "sale",
      label_for_internal_use: "SOLD Image Post", // Added
      post_type: "image_post",
      design_type: this.designTypes.property_post,
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.sold,
      agency_post: false,
      video_post: false,
    },
    sold_listing_story_post_agent_marketing: {
      slug: "sold_listing_story_post_agent_marketing",
      label: "SOLD Story Post",
      listing_type: "sale",
      label_for_internal_use: "SOLD Story Post", // Added
      post_type: "story_post",
      design_type: this.designTypes.property_post,
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.sold,
      agency_post: false,
      video_post: false,
    },

    leased_image_post_agent_marketing: {
      slug: "leased_image_post_agent_marketing",
      label: "LEASED post",
      listing_type: "rent",
      label_for_internal_use: "LEASED post", // Added
      post_type: "image_post",
      design_type: this.designTypes.property_post,
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.leased,
      agency_post: false,
      video_post: false,
    },
    leased_story_post_agent_marketing: {
      slug: "leased_story_post_agent_marketing",
      label: "LEASED post",
      listing_type: "rent",
      label_for_internal_use: "LEASED post", // Added
      post_type: "story_post",
      design_type: this.designTypes.property_post,
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.leased,
      agency_post: false,
      video_post: false,
    },

    /**
     * Agent Marketing - Growth Plan - For Rent
     */

    review_for_rent_image_post: {
      slug: "review_for_rent_image_post",
      label: "Review Image Post",
      listing_type: "rent",
      label_for_internal_use: "Review Image Post - For Rent", // Added
      post_type: "image_post",
      design_type: this.designTypes.review_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    review_for_rent_story_post: {
      slug: "review_for_rent_story_post",
      label: "Review Story Post",
      listing_type: "rent",
      label_for_internal_use: "Review Story Post - For Rent", // Added
      post_type: "story_post",
      design_type: this.designTypes.review_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    review_recap_for_rent_image_post: {
      slug: "review_recap_for_rent_image_post",
      label: "Review Recap Image Post",
      listing_type: "rent",
      label_for_internal_use: "Review Recap Image Post - For Rent", // Added
      post_type: "image_post",
      design_type: this.designTypes.review_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    review_recap_for_rent_story_post: {
      slug: "review_recap_for_rent_story_post",
      label: "Review Recap Story Post",
      listing_type: "rent",
      label_for_internal_use: "Review Recap Story Post - For Rent", // Added
      post_type: "story_post",
      design_type: this.designTypes.review_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    leased_video_post_agent_marketing: {
      slug: "leased_video_post_agent_marketing",
      label: "LEASED Video post",
      listing_type: "rent",
      label_for_internal_use: "LEASED Video post", // Added
      post_type: "video_post",
      design_type: this.designTypes.property_post,
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.leased,
      agency_post: false,
      video_post: false,
    },
    leased_reel_post_agent_marketing: {
      slug: "leased_reel_post_agent_marketing",
      label: "LEASED Reel post",
      listing_type: "rent",
      label_for_internal_use: "LEASED Reel post", // Added
      post_type: "reel_post",
      design_type: this.designTypes.property_post,
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.leased,
      agency_post: false,
      video_post: false,
    },

    leased_recap_for_rent_image_post: {
      slug: "leased_recap_for_rent_image_post",
      label: "Leased Recap Carousel Post",
      listing_type: "rent",
      label_for_internal_use: "Leased Recap Carousel Post", // Added
      post_type: "image_post",
      design_type: this.designTypes.property_post,
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.leased,
      agency_post: false,
      video_post: false,
    },
    leased_recap_for_rent_story_post: {
      slug: "leased_recap_for_rent_story_post",
      label: "Leased Recap Carousel Post",
      listing_type: "rent",
      label_for_internal_use: "Leased Recap Carousel Post", // Added
      post_type: "story_post",
      design_type: this.designTypes.property_post,
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.leased,
      agency_post: false,
      video_post: false,
    },

    festival_for_rent_image_post: {
      slug: "festival_for_rent_image_post",
      label: "Festival Post",
      listing_type: "rent",
      label_for_internal_use: "Festival Post - For Rent", // Added
      post_type: "image_post",
      design_type: this.designTypes.property_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    festival_for_rent_story_post: {
      slug: "festival_for_rent_story_post",
      label: "Festival Post",
      listing_type: "rent",
      label_for_internal_use: "Festival Post - For Rent", // Added
      post_type: "story_post",
      design_type: this.designTypes.property_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    /**
     * Agent Marketing - Growth Plan - For Sale
     */

    review_for_sale_image_post: {
      slug: "review_for_sale_image_post",
      label: "Review Image Post",
      listing_type: "sale",
      label_for_internal_use: "Review Image Post - For Sale", // Added
      post_type: "image_post",
      design_type: this.designTypes.review_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    review_for_sale_story_post: {
      slug: "review_for_sale_story_post",
      label: "Review Story Post",
      listing_type: "sale",
      label_for_internal_use: "Review Story Post - For Sale", // Added
      post_type: "story_post",
      design_type: this.designTypes.review_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    review_recap_for_sale_image_post: {
      slug: "review_recap_for_sale_image_post",
      label: "Review Recap Image Post",
      listing_type: "sale",
      label_for_internal_use: "Review Recap Image Post - For Sale", // Added
      post_type: "image_post",
      design_type: "review_recap_post",
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    review_recap_story_post: {
      slug: "review_recap_story_post",
      label: "Review Recap Story Post",
      listing_type: "sale",
      label_for_internal_use: "Review Recap Story Post - For Sale", // Added
      post_type: "story_post",
      design_type: "review_recap_post",
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    under_offer_recap_for_sale_image_post: {
      slug: "under_offer_recap_for_sale_image_post",
      label: "Under Offer/Contract Recap - Carousel Image Post",
      listing_type: "sale",
      label_for_internal_use:
        "Under Offer/Contract Recap - Carousel Image Post", // Added
      post_type: "image_post",
      design_type: "monthly_under_offer_carousel_post",
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.under_offer,
      agency_post: false,
      video_post: false,
    },
    under_offer_recap_for_sale_story_post: {
      slug: "under_offer_recap_for_sale_story_post",
      label: "Under Offer/Contract Recap - Carousel Story Post",
      listing_type: "sale",
      label_for_internal_use:
        "Under Offer/Contract Recap - Carousel Story Post", // Added
      post_type: "story_post",
      design_type: "monthly_under_offer_carousel_post",
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.under_offer,
      agency_post: false,
      video_post: false,
    },

    sold_recap_for_sale_image_post: {
      slug: "sold_recap_for_sale_image_post",
      label: "Sold Recap - Carousel Image Post",
      listing_type: "sale",
      label_for_internal_use: "Sold Recap - Carousel Image Post", // Added
      post_type: "image_post",
      design_type: "sold_recap",
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.sold,
      agency_post: false,
      video_post: false,
    },
    sold_recap_for_sale_story_post: {
      slug: "sold_recap_for_sale_story_post",
      label: "Sold Recap - Carousel Story Post",
      listing_type: "sale",
      label_for_internal_use: "Sold Recap - Carousel Story Post", // Added
      post_type: "story_post",
      design_type: "sold_recap",
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.sold,
      agency_post: false,
      video_post: false,
    },

    festival_for_sale_image_post: {
      slug: "festival_for_sale_image_post",
      label: "Festival Image Post",
      listing_type: "sale",
      label_for_internal_use: "Festival Image Post - For Sale", // Added
      post_type: "image_post",
      design_type: this.designTypes.festival_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    festival_for_sale_story_post: {
      slug: "festival_for_sale_story_post",
      label: "Festival Story Post",
      listing_type: "sale",
      label_for_internal_use: "Festival Story Post - For Sale", // Added
      post_type: "story_post",
      design_type: this.designTypes.festival_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    onboarding_for_sale_image_post: {
      slug: "onboarding_for_sale_image_post",
      label: "Onboarding Image Post",
      listing_type: "sale",
      label_for_internal_use: "Onboarding Image Post - For Sale", // Added
      post_type: "image_post",
      design_type: this.designTypes.onboarding_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    onboarding_for_sale_story_post: {
      slug: "onboarding_for_sale_story_post",
      label: "Onboarding Story Post",
      listing_type: "sale",
      label_for_internal_use: "Onboarding Story Post - For Sale", // Added
      post_type: "story_post",
      design_type: this.designTypes.onboarding_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    announcement_for_sale_image_post: {
      slug: "announcement_for_sale_image_post",
      label: "Announcement Image Post",
      listing_type: "sale",
      label_for_internal_use: "Announcement Image Post - For Sale", // Added
      post_type: "image_post",
      design_type: this.designTypes.announcement_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
      disable_selection_by_agent: true,
    },
    announcement_for_sale_story_post: {
      slug: "announcement_for_sale_story_post",
      label: "Announcement Story Post",
      listing_type: "sale",
      label_for_internal_use: "Announcement Story Post - For Sale", // Added
      post_type: "story_post",
      design_type: this.designTypes.announcement_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
      disable_selection_by_agent: true,
    },

    sold_listing_video_post_agent_marketing: {
      slug: "sold_listing_video_post_agent_marketing",
      label: "SOLD Video Post",
      listing_type: "sale",
      label_for_internal_use: "SOLD Video Post", // Added
      post_type: "video_post",
      design_type: this.designTypes.property_post,
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.sold,
      agency_post: false,
      video_post: false,
    },
    sold_listing_reel_image_post_agent_marketing: {
      slug: "sold_listing_reel_image_post_agent_marketing",
      label: "SOLD Reel Post",
      listing_type: "sale",
      label_for_internal_use: "SOLD Reel Post", // Added
      post_type: "reel_post",
      design_type: this.designTypes.property_post,
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.sold,
      agency_post: false,
      video_post: false,
    },

    /**
     * Agent Marketing - Success Plan - For Rent
     */

    review_for_rent_video_post: {
      slug: "review_for_rent_video_post",
      label: "Review Video Post",
      listing_type: "rent",
      label_for_internal_use: "Review Video Post - For Rent", // Added
      post_type: "video_post",
      design_type: this.designTypes.review_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    review_for_rent_reel_post: {
      slug: "review_for_rent_reel_post",
      label: "Review Reel Post",
      listing_type: "rent",
      label_for_internal_use: "Review Reel Post - For Rent", // Added
      post_type: "reel_post",
      design_type: this.designTypes.review_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    review_recap_for_rent_video_post: {
      slug: "review_recap_for_rent_video_post",
      label: "Review Recap Video Post",
      listing_type: "rent",
      label_for_internal_use: "Review Recap Video Post - For Rent", // Added
      post_type: "video_post",
      design_type: "review_recap_post",
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    review_recap_for_rent_reel_post: {
      slug: "review_recap_for_rent_reel_post",
      label: "Review Recap Reel Post",
      listing_type: "rent",
      label_for_internal_use: "Review Recap Reel Post - For Rent", // Added
      post_type: "reel_post",
      design_type: "review_recap_post",
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    leased_recap_for_rent_video_post: {
      slug: "leased_recap_for_rent_video_post",
      label: "Leased Recap Video Post",
      listing_type: "rent",
      label_for_internal_use: "Leased Recap Video Post", // Added
      post_type: "video_post",
      design_type: "leased_recap_post",
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.leased,
      agency_post: false,
      video_post: false,
    },
    leased_recap_for_rent_reel_post: {
      slug: "leased_recap_for_rent_reel_post",
      label: "Leased Recap Reel Post",
      listing_type: "rent",
      label_for_internal_use: "Leased Recap Reel Post", // Added
      post_type: "reel_post",
      design_type: "leased_recap_post",
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.leased,
      agency_post: false,
      video_post: false,
    },

    festival_for_rent_video_post: {
      slug: "festival_for_rent_video_post",
      label: "Festival Video Post",
      listing_type: "rent",
      label_for_internal_use: "Festival Video Post - For Rent", // Added
      post_type: "video_post",
      design_type: this.designTypes.festival_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    festival_for_rent_reel_post: {
      slug: "festival_for_rent_reel_post",
      label: "Festival Reel Post",
      listing_type: "rent",
      label_for_internal_use: "Festival Reel Post - For Rent", // Added
      post_type: "reel_post",
      design_type: this.designTypes.festival_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    /**
     * Agent Marketing - Success Plan - For Sale
     */

    review_written_for_sale_video_post: {
      slug: "review_written_for_sale_video_post",
      label: "Review Written Video Post",
      listing_type: "sale",
      label_for_internal_use: "Review Written Video Post - For Sale", // Added
      post_type: "video_post",
      design_type: "review_written_post",
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    review_written_for_sale_reel_post: {
      slug: "review_written_for_sale_reel_post",
      label: "Review Written Reel Post",
      listing_type: "sale",
      label_for_internal_use: "Review Written Reel Post - For Sale", // Added
      post_type: "reel_post",
      design_type: "review_written_post",
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    shooted_review_for_sale_video_post: {
      slug: "shooted_review_for_sale_video_post",
      label: "Shooted Review Video Post",
      listing_type: "sale",
      label_for_internal_use: "Shooted Review Video Post - For Sale", // Added
      post_type: "video_post",
      design_type: "shooted_review_post",
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    shooted_review_for_sale_reel_post: {
      slug: "shooted_review_for_sale_reel_post",
      label: "Shooted Review Reel Post",
      listing_type: "sale",
      label_for_internal_use: "Shooted Review Reel Post - For Sale", // Added
      post_type: "reel_post",
      design_type: "shooted_review_post",
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    review_written_recap_for_sale_video_post: {
      slug: "review_written_recap_for_sale_video_post",
      label: "Review Written Recap Video Post",
      listing_type: "sale",
      label_for_internal_use: "Review Written Recap Video Post - For Sale", // Added
      post_type: "video_post",
      design_type: "review_written_recap_post",
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    review_written_recap_for_sale_reel_post: {
      slug: "review_written_recap_for_sale_reel_post",
      label: "Review Written Recap Reel Post",
      listing_type: "sale",
      label_for_internal_use: "Review Written Recap Reel Post - For Sale", // Added
      post_type: "reel_post",
      design_type: "review_written_recap_post",
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    under_offer_recap_for_sale_video_post: {
      slug: "under_offer_recap_for_sale_video_post",
      label: "Under Offer/Contract Recap Video Post",
      listing_type: "sale",
      label_for_internal_use: "Under Offer/Contract Recap Video Post", // Added
      post_type: "video_post",
      design_type: "under_offer_recap_post",
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.under_offer,
      agency_post: false,
      video_post: false,
    },
    under_offer_recap_for_sale_reel_post: {
      slug: "under_offer_recap_for_sale_reel_post",
      label: "Under Offer/Contract Recap Reel Post",
      listing_type: "sale",
      label_for_internal_use: "Under Offer/Contract Recap Reel Post", // Added
      post_type: "reel_post",
      design_type: "under_offer_recap_post",
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.under_offer,
      agency_post: false,
      video_post: false,
    },

    sold_recap_for_sale_video_post: {
      slug: "sold_recap_for_sale_video_post",
      label: "Sold Recap Video Post",
      listing_type: "sale",
      label_for_internal_use: "Sold Recap Video Post", // Added
      post_type: "video_post",
      design_type: "sold_recap",
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.sold,
      agency_post: false,
      video_post: false,
    },
    sold_recap_for_sale_reel_post: {
      slug: "sold_recap_for_sale_reel_post",
      label: "Sold Recap Reel Post",
      listing_type: "sale",
      label_for_internal_use: "Sold Recap Reel Post", // Added
      post_type: "reel_post",
      design_type: "sold_recap",
      subscription_type: "agent_marketing",
      stage_id: this.propertyStageIds.sold,
      agency_post: false,
      video_post: false,
    },

    festival_post_for_sale_video_post: {
      slug: "festival_post_for_sale_video_post",
      label: "Festival Video Post",
      listing_type: "sale",
      label_for_internal_use: "Festival Video Post - For Sale", // Added
      post_type: "video_post",
      design_type: this.designTypes.festival_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    festival_post_for_sale_reel_post: {
      slug: "festival_post_for_sale_reel_post",
      label: "Festival Reel Post",
      listing_type: "sale",
      label_for_internal_use: "Festival Reel Post - For Sale", // Added
      post_type: "reel_post",
      design_type: this.designTypes.festival_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    onboarding_post_for_sale_video_post: {
      slug: "onboarding_post_for_sale_video_post",
      label: "Onboarding Video Post",
      listing_type: "sale",
      label_for_internal_use: "Onboarding Video Post - For Sale", // Added
      post_type: "video_post",
      design_type: this.designTypes.onboarding_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },
    onboarding_post_for_sale_reel_post: {
      slug: "onboarding_post_for_sale_reel_post",
      label: "Onboarding Reel Post",
      listing_type: "sale",
      label_for_internal_use: "Onboarding Reel Post - For Sale", // Added
      post_type: "reel_post",
      design_type: this.designTypes.onboarding_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
    },

    announcement_post_for_sale_video_post: {
      slug: "announcement_post_for_sale_video_post",
      label: "Announcement Video Post",
      listing_type: "sale",
      label_for_internal_use: "Announcement Video Post - For Sale", // Added
      post_type: "video_post",
      design_type: this.designTypes.announcement_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
      disable_selection_by_agent: true,
    },
    announcement_post_for_sale_reel_post: {
      slug: "announcement_post_for_sale_reel_post",
      label: "Announcement Reel Post",
      listing_type: "sale",
      label_for_internal_use: "Announcement Reel Post - For Sale", // Added
      post_type: "reel_post",
      design_type: this.designTypes.announcement_post,
      subscription_type: "agent_marketing",
      agency_post: false,
      video_post: false,
      disable_selection_by_agent: true,
    },
  };
}
